module.exports = __webpack_public_path__ + "img/brand7-Photo.4eb6dc4d.png";